import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ProjectDetailsService implements OnDestroy {

  triggerSave: Subject<any> = new Subject();
  save: Subject<any> = new Subject();
  addComment: Subject<any> = new Subject();
  disableAddMenu: Subject<any> = new Subject();
  disableOptionMenu: Subject<any> = new Subject();
  hideDeleteOption: Subject<any> = new Subject();
  triggerDelete: Subject<any> = new Subject();
  delete: Subject<any> = new Subject();
  selectedLocation: Subject<any> = new Subject();
  /** Daily reports tab: ids of the reports the filters currently show (all pages). */
  filteredDailyReportIds = new BehaviorSubject<string[]>([]);

  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    public dialog: MatDialog,
    public route: ActivatedRoute,
  ) {

  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }


}
